<template>
    <v-dialog v-model="dialog" scrollable width="50%">
        <v-card>
            <v-container>
                <v-card-title>{{this.header}}</v-card-title>
                <v-tabs v-model="tab" class="pl-4">
                    <v-tab v-for="lng in languages" :key="lng.sort">
                        {{ lng.language}}
                    </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">
                    <v-tab-item v-for="lng in languages" :key="lng.sort">
                        <v-card flat height="300px">
                            <v-container>
                                <v-textarea v-model="lng.text" rows="10" readonly class="ml-8 mr-4"></v-textarea>
                            </v-container>
                        </v-card>
                    </v-tab-item>
                </v-tabs-items>
                <br>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" small @click="dialog = false">Close</v-btn>
                </v-card-actions>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {

        data () {
            return {
                tab: null,
                header: '',
                dialog: false,
                languages: [],
            }
        },  
        methods: {
            open(header, texts, tab) {      
                console.log(header, tab);
                this.header = header;
                this.dialog = true;
                this.languages = texts
                this.tab = tab;
            },    
            close() {
                // leegmaken
                this.header = '';
                this.tab = null;
                this.text = [];
                this.dialog = false;
            },
        }        
    }
</script>

<style scoped>

</style>